/** KPI card for the dashboard. */
import type { ReactNode } from 'react';
import { Card } from './ui';

export function StatCard({
  label,
  value,
  sublabel,
  tone = 'neutral',
  loading = false,
}: {
  label: string;
  value: ReactNode;
  sublabel?: string;
  tone?: 'neutral' | 'brand' | 'amber' | 'emerald';
  loading?: boolean;
}): JSX.Element {
  const accent = {
    neutral: 'text-slate-900',
    brand: 'text-brand-600',
    amber: 'text-amber-600',
    emerald: 'text-emerald-600',
  }[tone];

  return (
    <Card className="p-5">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
      {loading ? (
        <div className="mt-2 h-8 w-16 animate-pulse rounded bg-slate-200" />
      ) : (
        <p className={`mt-1 text-3xl font-semibold tracking-tight ${accent}`}>{value}</p>
      )}
      {sublabel && <p className="mt-1 text-xs text-slate-500">{sublabel}</p>}
    </Card>
  );
}
